import React from 'react'
import { string, node } from 'prop-types'
import * as Styled from './ContentSection.styles'
import { Grid } from 'components/atoms'

const ContentSection = ({ title, children, ...rest }) => (
  <Styled.ContentSection
    { ...rest }
    data-cy-title={ title }
    data-cy='cross-search-container'>
    <Grid container>
      <Grid item xs={ 12 } sm={ 4 } className='no-padding'>
        <div className='title'>{title}</div>
      </Grid>
      {children && (
        <Grid item xs={ 12 } sm={ 8 } className='content'>
          {children}
        </Grid>
      )}
    </Grid>
  </Styled.ContentSection>
)

ContentSection.defaultProps = {
  children: false,
}

ContentSection.propTypes = {
  title: string.isRequired,
  children: node,
}

export default ContentSection
